<template>
  <DetailBox :info="detailInfo" title="Detail"
             @onClickButton="selectEarthquakeIndex(detailBox.quickEarthquakeIndex)"
             @onClose="detailBox.showDetail=false"
             :showBox="detailBox.showDetail"
             :showButton="detailBox.showButton"></DetailBox>
  <el-row class="toolbar">
    <el-select v-model="imageryConfig.mapStyle" placeholder="请选择" class="toolbar-item">
      <el-option v-for="item in imageryConfig.options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
    </el-select>
    <el-popover ref="controlVisible" placement="bottom" trigger="click" v-model:visible="layerControl.visible" width="170px">
      <template #reference>
        <el-button type="default" icon="el-icon-menu" round class="toolbar-item">layer control</el-button>
      </template>
      <el-checkbox v-model="layerControl.showIntensity" label="intensity map"></el-checkbox><br/>
      <el-checkbox v-model="layerControl.showEpicenter" label="epicenter"></el-checkbox>
      <el-checkbox v-model="layerControl.showHospital" label="hospital"></el-checkbox>
      <el-checkbox v-model="layerControl.showModel" label="3dTile"></el-checkbox>
      <el-tooltip placement="right" effect="light">
        <template #content>
          default amount of supplies is 1000
        </template>
        <el-checkbox v-model="layerControl.showFireCenter" label="distribution of supplies"></el-checkbox>
      </el-tooltip>
      <el-collapse v-model="activeCalculateWeight" @change="handleChangeWeight" v-loading="fireCenterLoading" element-loading-text="calculating">
        <el-collapse-item title="show more" name="1">
          amount of supplies:
          <el-input-number v-model="DistributionSum" :step="100" size="small" style="margin-top: 10px;"/>
          set count of district:
          <el-input-number v-model="DistrictSum" :step="5" size="small" style="margin-top: 10px;" :min="5" :max="30"/>
          <el-button type="primary" icon="el-icon-success" size="small" @click="reGetCalculateWeight" style="margin-top: 10px;margin-left: 60px">计算</el-button>
        </el-collapse-item>
      </el-collapse>
    </el-popover>
    <el-button type="primary" round
               v-on:click="cameraTo(earthquakeInfoList[selectedEarthquakeIndex].longitude,earthquakeInfoList[selectedEarthquakeIndex].latitude,100000)"
               icon="el-icon-s-flag"
               class="toolbar-item">jump to</el-button>
<!--    <el-button type="primary" round-->
<!--               v-on:click="startDraw"-->
<!--               icon="el-icon-s-flag"-->
<!--               class="toolbar-item">开始画方块</el-button>-->
<!--    <el-button type="primary" round-->
<!--               v-on:click="stopDraw"-->
<!--               icon="el-icon-s-flag"-->
<!--               class="toolbar-item">结束画方块</el-button>-->
    <EarthquakeSelect
        :earthquakeInfoList="earthquakeInfoList"
        :selectedEarthquakeIndex="selectedEarthquakeIndex"
        @changeSelect="selectEarthquakeIndex"
        @updateList="getEarthquakeList"
        @newList="updateEarthquakeList"
        @jumpTo="cameraTo"
    ></EarthquakeSelect>
    <EstimateEarthquake :earthquake="earthquakeInfoList[selectedEarthquakeIndex]"></EstimateEarthquake>
    <AddEarthquake></AddEarthquake>
    <!-- hyc2 -->
<!--    <el-button-->
<!--        type="primary"-->
<!--        round-->
<!--        @click="getPositionRoad"-->
<!--        class="toolbar-item"-->
<!--    >开始路径规划</el-button>-->
    <el-popover
        v-model:visible="visibleRoad"
        placement="bottom"
        :width="420"
    >
      <template #reference>
        <el-button @click="visibleRoad = !visibleRoad" class="toolbar-item" round>
          Path planning
        </el-button>
      </template>
      <div>
        <el-radio v-model="radioRoad" label="1" size="small" border>car</el-radio>
        <el-radio v-model="radioRoad" label="2" size="small" border>walk</el-radio>
        <el-radio v-model="radioRoad" label="3" size="small" border>Non-Motor Vehicle</el-radio>
      </div>
      <div style="margin-top: 20px">
        <el-button type="primary" icon="el-icon-magic-stick" size="small" @click="selectPositionRoad">select point</el-button>
        <el-button type="primary" icon="el-icon-search" size="small" @click="getPositionRoad">start</el-button>
        <el-button type="danger" icon="el-icon-s-release" size="small" @click="stopPositionRoad">stop</el-button>
      </div>
    </el-popover>

  </el-row>
  <el-row ref="viewerContainer" class="viewer" v-loading="cesiumLoading" element-loading-text="The initial loading may be a little slow, please wait patiently">
    <vc-viewer
        ref="vcViewer"
        :animation="viewerConfig.animation"
        :baseLayerPicker="viewerConfig.baseLayerPicker"
        :timeline="viewerConfig.timeline"
        :fullscreenButton="viewerConfig.fullscreenButton"
        :fullscreenElement="viewerConfig.fullscreenElement"
        :infoBox="viewerConfig.infoBox"
        :selectionIndicator="false"
        :showCredit="viewerConfig.showCredit"
        @ready="onViewerReady"
    >
<!--      <vc-datasource-geojson-->
<!--          ref="datasourceRef"-->
<!--          data="/jinniucun.json"-->
<!--          stroke="red"-->
<!--      ></vc-datasource-geojson>-->
      <vc-primitive-tileset
          ref="primitive"
          url="/3dtile/tileset.json"
          :show="layerControl.showModel"
          @ready-promise="onReadyPromise"
          @click="onClicked"
      >
        <!--          :skip-level-of-detail="true"
          :base-screen-space-error="1024"
          :maximum-screen-space-error="256"
          :skip-levels="1"
          :skip-screen-space-error-factor="16"
          :immediately-load-desired-level-of-detail="false"
          :load-siblings="true"
          :cull-with-children-bounds="true"
          :cull-requests-while-moving="true"
          :cull-requests-while-moving-multiplier="10"
          :preload-when-hidden="true"
          :prefer-leaves="true"
          :maximum-memory-usage="128"
          :progressive-resolution-height-fraction="0.5"
          :dynamic-screen-space-error-density="0.1"
          :dynamic-screen-space-error-factor="1"
          :dynamic-screen-space-error="true"-->
      </vc-primitive-tileset>
      <vc-entity :description="1">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01859588778927 ,lat: 25.62962953710863},{lng: 100.01881168155978 ,lat: 25.629510203504957},{lng: 100.01874625853046 ,lat: 25.62942367290686},{lng: 100.01852898117171 ,lat: 25.629546838422765},]"
            :material="[255,241,0,125]"
            :extruded-height="25.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="2">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0186994686935 ,lat: 25.629473927698207},{lng: 100.01876052518081 ,lat: 25.629442922570853},{lng: 100.01864762036739 ,lat: 25.629324639025647},{lng: 100.01849991570985 ,lat: 25.629404405868073},{lng: 100.01853721428753 ,lat: 25.629450061618897},{lng: 100.01863340044123 ,lat: 25.629396451737385},]"
            :material="[255,241,0,125]"
            :extruded-height="25.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="3">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01841353653957 ,lat: 25.629191602198247},{lng: 100.01843547496863 ,lat: 25.629121853454368},{lng: 100.01855872358901 ,lat: 25.62914720198447},{lng: 100.01854152627175 ,lat: 25.629223518663217},]"
            :material="[255,241,0,125]"
            :extruded-height="30.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="4">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01839802649292 ,lat: 25.62915067723292},{lng: 100.01845145807657 ,lat: 25.62909889107982},{lng: 100.01838721946774 ,lat: 25.62903639510705},{lng: 100.01832383747923 ,lat: 25.62909267777556},]"
            :material="[255,241,0,125]"
            :extruded-height="30.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="5">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01830555769152 ,lat: 25.629000478102352},{lng: 100.01835029499303 ,lat: 25.628928320838714},{lng: 100.01820978443823 ,lat: 25.628864130645315},{lng: 100.01816675156934 ,lat: 25.628931960634617},]"
            :material="[255,241,0,125]"
            :extruded-height="35"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="6">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01845529297407 ,lat: 25.628607739215347},{lng: 100.01832785773175 ,lat: 25.628532728122746},{lng: 100.01820613458584 ,lat: 25.628741096845438},{lng: 100.01840603924404 ,lat: 25.628856768026846},{lng: 100.01847143103117 ,lat: 25.62879905290432},{lng: 100.0183439017443 ,lat: 25.628723787819577},]"
            :material="[255,241,0,125]"
            :extruded-height="45.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="7">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01786736249099 ,lat: 25.628677810937017},{lng: 100.01792272711079 ,lat: 25.628569358777117},{lng: 100.01803403024721 ,lat: 25.628612585903245},{lng: 100.01798779692938 ,lat: 25.628718070864224},]"
            :material="[0,255,0,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="8">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01806458647424 ,lat: 25.628645214643345},{lng: 100.01810697252813 ,lat: 25.628539491680755},{lng: 100.0181900306035 ,lat: 25.628561266859162},{lng: 100.01812554374986 ,lat: 25.628658284474216},]"
            :material="[0,255,0,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="9">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0181907918625 ,lat: 25.628552022470465},{lng: 100.01823475847542 ,lat: 25.62844333573642},{lng: 100.01834462458646 ,lat: 25.628485211035706},{lng: 100.01831685422262 ,lat: 25.628586079876513},]"
            :material="[0,255,0,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>


      <vc-entity :description="10">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01841965571329 ,lat: 25.629299746435265}, {lng: 100.01830722406768 ,lat: 25.6291951903786}, {lng: 100.01818131234776 ,lat: 25.62929219903646},{lng: 100.01829179582712 ,lat: 25.62936680214079}]"
            :material="[255,241,0,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="11">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01894748890419 ,lat: 25.629025605714208},
            {lng: 100.01895080372456 ,lat: 25.628955003547414},
            {lng: 100.01905481620972 ,lat: 25.62880539324567},
            {lng: 100.01916327571378 ,lat: 25.628811487682338},
            {lng: 100.01914674878452 ,lat: 25.629022838175743},
            {lng: 100.01893760226857 ,lat: 25.629034609752182}]"
            :material="[0,255,0,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="12">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01864380593356 ,lat: 25.628929660197656},
            {lng: 100.01875142760767 ,lat: 25.62878758230447},
            {lng: 100.01860450943948 ,lat: 25.62872673635103},
            {lng: 100.01848815005665 ,lat: 25.628863526648846}]"
            :material="[255,241,0,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="13">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01894748890419 ,lat: 25.629025605714208},
            {lng: 100.01895080372456 ,lat: 25.628955003547414},
            {lng: 100.01905481620972 ,lat: 25.62880539324567},
            {lng: 100.01916327571378 ,lat: 25.628811487682338},
            {lng: 100.01914674878452 ,lat: 25.629022838175743},
            {lng: 100.01893760226857 ,lat: 25.629034609752182}]"
            :material="[0,255,0,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>

      <vc-entity :description="14">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01846704899464 ,lat: 25.628442477358423},
            {lng: 100.01848565469423 ,lat: 25.628332185818277},
            {lng: 100.01859883591472 ,lat: 25.628343820240715},
            {lng: 100.01860224727646 ,lat: 25.628276054296254},
            {lng: 100.01874664590619 ,lat: 25.62829691618321},
            {lng: 100.01869534427712 ,lat: 25.62853477335218}]"
            :material="[0,255,0,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="15">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01878824220216 ,lat: 25.6286079386436},
            {lng: 100.01893281122592 ,lat: 25.628669170029674},
            {lng: 100.01902416637213 ,lat: 25.62853090909095},
            {lng: 100.01886922721302 ,lat: 25.628453682366427}]"
            :material="[255,241,0,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="16">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01801972829284 ,lat: 25.628090487473514},
            {lng: 100.01805523324963 ,lat: 25.627996177358348},
            {lng: 100.01827809658131 ,lat: 25.628062176051042},
            {lng: 100.01819348860403 ,lat: 25.62826559616586},
            {lng: 100.01810376354153 ,lat: 25.628233619421923},
            {lng: 100.01814412907079 ,lat: 25.62813899873284}]"
            :material="[197,48,55,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="17">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01816577049566 ,lat: 25.62797393905156},
            {lng: 100.01818336313316 ,lat: 25.627860560610177},
            {lng: 100.01833734338054 ,lat: 25.627902244432775},
            {lng: 100.01830652914272 ,lat: 25.6280143593605}]"
            :material="[255,241,0,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="18">
        <vc-graphics-polygon
            :hierarchy="[{ lng: 100.02060, lat: 25.62903 }, { lng: 100.02054, lat: 25.62913 }, { lng: 100.02072, lat: 25.62919 },{ lng: 100.02079, lat: 25.62908 }]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="19">
        <vc-graphics-polygon
            :hierarchy="[{ lng: 100.02017, lat: 25.62855 }, { lng: 100.02001, lat: 25.62870 }, { lng: 100.02033, lat: 25.62885 },{ lng: 100.02046, lat: 25.62873 }]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="20">
        <vc-graphics-polygon
            :hierarchy="[{ lng: 100.01922, lat: 25.62779 }, { lng: 100.01944, lat: 25.62792 }, { lng: 100.01936, lat: 25.62808 },{ lng: 100.01904, lat: 25.62796 }]"
            :material="[255,241,0,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="destruction">
        <vc-graphics-polygon
            :hierarchy="[{ lng: 100.02047, lat: 25.62780 }, { lng: 100.02033, lat: 25.62789 }, { lng: 100.02046, lat: 25.62804 },{ lng: 100.02061, lat: 25.62796 }]"
            :material="[197,48,55,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="22">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01916712757586 ,lat: 25.62835720715622},
            {lng: 100.01923798923697 ,lat: 25.628228137717812},
            {lng: 100.01937796875696 ,lat: 25.62829397819061},
            {lng: 100.01931504151358 ,lat: 25.6284142519409}]"
            :material="[255,241,0,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="23">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01837299379082 ,lat: 25.62809034299207},
            {lng: 100.01840938510256 ,lat: 25.627942448159875},
            {lng: 100.01853219177713 ,lat: 25.62796228623809},
            {lng: 100.0184989317797 ,lat: 25.628123365713723}]"
            :material="[255,241,0,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="24">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01871231624686 ,lat: 25.62784862020635},
            {lng: 100.01855189703566 ,lat: 25.62777911707835},
            {lng: 100.01864146575367 ,lat: 25.62764660951482},
            {lng: 100.01881200703414 ,lat: 25.62773336602962}]"
            :material="[0,255,0,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="25">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01954545123645 ,lat: 25.629007541782855},{lng: 100.01955943408124 ,lat: 25.62892658631184},{lng: 100.01972015418531 ,lat: 25.628946196984867},{lng: 100.01970115956 ,lat: 25.629034549781004},]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="26">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01822825921141 ,lat: 25.627696071370874},
            {lng: 100.01831613458867 ,lat: 25.6275342028935},
            {lng: 100.01845066345429 ,lat: 25.62758978569067},
            {lng: 100.01836811222758 ,lat: 25.627744541432442}]"
            :material="[0,255,0,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="27">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01900936824258 ,lat: 25.628563995382667},{lng: 100.01903544872422 ,lat: 25.62848306987864},{lng: 100.01920211300987 ,lat: 25.62852367708238},{lng: 100.0191839417904 ,lat: 25.62862562343929},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="28">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0190197093543 ,lat: 25.627952364712854},
            {lng: 100.01881995120551 ,lat: 25.62796186521579},
            {lng: 100.01882748859572 ,lat: 25.627827089118018},
            {lng: 100.01904263319084 ,lat: 25.627850771712996}]"
            :material="[255,241,0,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="29">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0197356503693 ,lat: 25.62856196470555},{lng: 100.01975682823533 ,lat: 25.628479124781876},{lng: 100.01988973509714 ,lat: 25.62850726638844},{lng: 100.01987684398765 ,lat: 25.62857999712085},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="30">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01949528139534 ,lat: 25.628080437189578},{lng: 100.01954459924775 ,lat: 25.628012176802702},{lng: 100.01972497061715 ,lat: 25.628109726084112},{lng: 100.01969143988755 ,lat: 25.628186776324778},]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="31">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01882906535876 ,lat: 25.62773376978877},
            {lng: 100.01887759863428 ,lat: 25.62754190598998},
            {lng: 100.01907316941768 ,lat: 25.627589217100663},
            {lng: 100.0189441454971 ,lat: 25.627814272427333}]"
            :material="[255,146,13,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="32">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01984032742159 ,lat: 25.629453794919215},
            {lng: 100.01987831751765 ,lat: 25.629380864083146},
            {lng: 100.02012780532397 ,lat: 25.629450271126338},
            {lng: 100.02008411172147 ,lat: 25.629546912313142}]"
            :material="[255,241,0,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="33">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02012300302997 ,lat: 25.629423763699418},
            {lng: 100.0201324093808 ,lat: 25.629310741849046},
            {lng: 100.02037848887989 ,lat: 25.6293420648882},
            {lng: 100.02036613057005 ,lat: 25.62946857075574}]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="34">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0199867287068 ,lat: 25.62905523370133},
            {lng: 100.02003715615777 ,lat: 25.628912042202156},
            {lng: 100.02041650002998 ,lat: 25.62908916962386},
            {lng: 100.02034653053208 ,lat: 25.629209944339532}]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="35">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01971263006858 ,lat: 25.627921082281695},
            {lng: 100.01954447904039 ,lat: 25.627827922948338},
            {lng: 100.0197121236969 ,lat: 25.627648011569597},
            {lng: 100.01987004498456 ,lat: 25.627810696487003}]"
            :material="[255,241,0,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="36">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0195449467642 ,lat: 25.627492884821322},
            {lng: 100.01927455230714 ,lat: 25.627370664906955},
            {lng: 100.01939202743534 ,lat: 25.62715344450887},
            {lng: 100.01970518164492 ,lat: 25.6273397059003}]"
            :material="[255,146,13,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="37">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02017930852577 ,lat: 25.62741084134393},
            {lng: 100.0200144921976 ,lat: 25.627277250487417},
            {lng: 100.02004312490952 ,lat: 25.62718395173301},
            {lng: 100.02025504869613 ,lat: 25.62736770591035}]"
            :material="[77, 158, 252,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="39">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02024029367271 ,lat: 25.627522813639708},
            {lng: 100.02035574029836 ,lat: 25.627437388696553},
            {lng: 100.02051354487408 ,lat: 25.62754656191605},
            {lng: 100.02041302943131 ,lat: 25.627656294355308}]"
            :material="[255,241,0,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="40">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02091891879878 ,lat: 25.62897987801184},{lng: 100.0209843994633 ,lat: 25.62885438512872},{lng: 100.02107612855929 ,lat: 25.628870525589598},{lng: 100.02100231115757 ,lat: 25.628996300583793},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="41">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02039429432199 ,lat: 25.628396713261417},
            {lng: 100.02044443328698 ,lat: 25.628287195481743},
            {lng: 100.02069508699711 ,lat: 25.628427949769453},
            {lng: 100.02066202421908 ,lat: 25.628557687207337}]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="42">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02113544715986 ,lat: 25.629001059897515},
            {lng: 100.02112121263505 ,lat: 25.628840114428904},
            {lng: 100.0212611509371 ,lat: 25.628802369459216},
            {lng: 100.02133191005714 ,lat: 25.62902379403942}]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="43">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0208504960849 ,lat: 25.628475449511566},{lng: 100.02087851240654 ,lat: 25.62838757714694},{lng: 100.02103325919428 ,lat: 25.62846162292306},{lng: 100.02098197798281 ,lat: 25.628532885785777},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="44">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02062157505087 ,lat: 25.628241414568286},
            {lng: 100.02068389468978 ,lat: 25.62815540793149},
            {lng: 100.02082407110565 ,lat: 25.628262255439108},
            {lng: 100.02073296910913 ,lat: 25.62835684392077}]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="45">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02097446957251 ,lat: 25.629232678623893},
            {lng: 100.02104733134075 ,lat: 25.629123855619618},
            {lng: 100.02117813952142 ,lat: 25.62914047257642},
            {lng: 100.02114735675433 ,lat: 25.62925863873084}]"
            :material="[197,48,55,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="46">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02116232762106 ,lat: 25.629584960692387},
            {lng: 100.02131640794794 ,lat: 25.62946377320047},
            {lng: 100.02149748095671 ,lat: 25.62959409819221},
            {lng: 100.02137242473901 ,lat: 25.629731946018854}]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="47">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01942369099015 ,lat: 25.62824062119174},
            {lng: 100.0194929559917 ,lat: 25.628144673548643},
            {lng: 100.01969116593781 ,lat: 25.628255748136713},
            {lng: 100.01962201056293 ,lat: 25.628368725044485}]"
            :material="[255,241,0,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="48">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01896871928888 ,lat: 25.62993213243803},
            {lng: 100.01889847251253 ,lat: 25.629869204610277},
            {lng: 100.01898989713897 ,lat: 25.629779636536846},
            {lng: 100.01908863961808 ,lat: 25.629862390432496}]"
            :material="[77, 158, 252,125]"
            :extruded-height="80.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="49">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01930996673849 ,lat: 25.629753309389724},
            {lng: 100.01930832952448 ,lat: 25.6296844589447},
            {lng: 100.01951058776551 ,lat: 25.629687108597544},
            {lng: 100.01949375070826 ,lat: 25.629767745214284}]"
            :material="[197,48,55,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="50">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01935538202524 ,lat: 25.629525923617024},
            {lng: 100.01939804729372 ,lat: 25.629457753475627},
            {lng: 100.01955235412777 ,lat: 25.62949211606107},
            {lng: 100.01953427099585 ,lat: 25.629559296917467}]"
            :material="[197,48,55,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="51">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01905033772633 ,lat: 25.627358236267742},
            {lng: 100.01908889126379 ,lat: 25.6272591182023},
            {lng: 100.01929580398098 ,lat: 25.62736755156529},
            {lng: 100.01924791055052 ,lat: 25.627480437877406}]"
            :material="[77, 158, 252,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="52">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02017993920737 ,lat: 25.627485956202126},
            {lng: 100.02001007378026 ,lat: 25.627427466153428},
            {lng: 100.02009333509406 ,lat: 25.627359677762},
            {lng: 100.02022014055692 ,lat: 25.627419615088865}]"
            :material="[255,241,0,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="53">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01939119966462 ,lat: 25.626626619418076},
            {lng: 100.01950336809345 ,lat: 25.626531982284224},
            {lng: 100.01968722909758 ,lat: 25.626660707537336},
            {lng: 100.01960336982738 ,lat: 25.626757638979743}]"
            :material="[77, 158, 252,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="54">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01957746607523 ,lat: 25.626796625004395},
            {lng: 100.01963674260101 ,lat: 25.62672042549515},
            {lng: 100.01974323498973 ,lat: 25.62680072436906},
            {lng: 100.01968901791957 ,lat: 25.62687234473471}]"
            :material="[255,241,0,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="55">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01984403667677 ,lat: 25.62681075283697},
            {lng: 100.01972579690954 ,lat: 25.626743302255722},
            {lng: 100.01978042420589 ,lat: 25.626684796548524},
            {lng: 100.01989410799035 ,lat: 25.626766456187628}]"
            :material="[77, 158, 252,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="56">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02004926168973 ,lat: 25.627152039882148},
            {lng: 100.01992991478222 ,lat: 25.627070467262758},
            {lng: 100.0200445979443 ,lat: 25.627010813760403},
            {lng: 100.02014217469666 ,lat: 25.627093063037847}]"
            :material="[0,255,0,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="57">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01938797512177 ,lat: 25.626915257146972},
            {lng: 100.01943513161137 ,lat: 25.626855474922323},
            {lng: 100.0195628996872 ,lat: 25.626898371478607},
            {lng: 100.01953653295708 ,lat: 25.62694915014596}]"
            :material="[197,48,55,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="58">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01883245780812 ,lat: 25.626549892002917},
            {lng: 100.01895020992957 ,lat: 25.626398596708533},
            {lng: 100.0191246357684 ,lat: 25.626470516167114},
            {lng: 100.01902015094542 ,lat: 25.626616346039093}]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="59">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01924744766048 ,lat: 25.629223415446468},
            {lng: 100.01929234362308 ,lat: 25.62911144898533},
            {lng: 100.01948266108604 ,lat: 25.62912490999263},
            {lng: 100.01943733757575 ,lat: 25.629260049630524}]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="60">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01939736713149 ,lat: 25.62907880064362},
            {lng: 100.01943634539653 ,lat: 25.628972538460356},
            {lng: 100.01959637498643 ,lat: 25.629031630802405},
            {lng: 100.01956816476068 ,lat: 25.629123332492725}]"
            :material="[77, 158, 252,125]"
            :extruded-height="90.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="61">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01965339406517 ,lat: 25.627072056852636},
            {lng: 100.01972010048269 ,lat: 25.626934020688505},
            {lng: 100.01994485306777 ,lat: 25.627075202890424},
            {lng: 100.01988690275994 ,lat: 25.62719778706885}]"
            :material="[255,241,0,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="62">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02011310076209 ,lat: 25.62783471579344},
            {lng: 100.02018713080902 ,lat: 25.627708277434404},
            {lng: 100.02035111867224 ,lat: 25.62777779093206},
            {lng: 100.0202767904026 ,lat: 25.6279035841137}]"
            :material="[0,255,0,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="63">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0199242992064 ,lat: 25.62760558919001},
            {lng: 100.01990218438199 ,lat: 25.627373467143734},
            {lng: 100.01998773352099 ,lat: 25.62736303136359},
            {lng: 100.02001924288727 ,lat: 25.627589146930955}]"
            :material="[77, 158, 252,125]"
            :extruded-height="100.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="64">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02115115670335 ,lat: 25.627603401902615},
            {lng: 100.02101701654311 ,lat: 25.627478086693127},
            {lng: 100.02127780876481 ,lat: 25.627208310101302},
            {lng: 100.02141258184128 ,lat: 25.62734171212576}]"
            :material="[255,241,0,125]"
            :extruded-height="50.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="65">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01972754465437 ,lat: 25.626016378074482},
            {lng: 100.01972031021005 ,lat: 25.62587699847837},
            {lng: 100.01998010541652 ,lat: 25.625914180846266},
            {lng: 100.0199926006627 ,lat: 25.626046754582585}]"
            :material="[77, 158, 252,125]"
            :extruded-height="50.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="66">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01948397688088 ,lat: 25.62627978296092},
            {lng: 100.01957867076584 ,lat: 25.626057688645684},
            {lng: 100.0197414318238 ,lat: 25.62611466224472},
            {lng: 100.01965768929242 ,lat: 25.62628345952133}]"
            :material="[77, 158, 252,125]"
            :extruded-height="50.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="67">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01981033798354 ,lat: 25.62579923702777},
            {lng: 100.0198388295096 ,lat: 25.625636366835483},
            {lng: 100.02008543173096 ,lat: 25.625704950831114},
            {lng: 100.02006281574897 ,lat: 25.625852998466947}]"
            :material="[197,48,55,125]"
            :extruded-height="50.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="68">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01852801338065 ,lat: 25.626702252365444},
            {lng: 100.01859929547216 ,lat: 25.626617810978892},
            {lng: 100.01880856731934 ,lat: 25.626705618587504},
            {lng: 100.01874869508018 ,lat: 25.62683371243047}]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="69">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01857489772686 ,lat: 25.62662774707545},
            {lng: 100.01837600529063 ,lat: 25.62655656062987},
            {lng: 100.01847685247489 ,lat: 25.62638135449738},
            {lng: 100.0186827670212 ,lat: 25.62646713979619}]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="70">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01836613127414 ,lat: 25.62685812885852},
            {lng: 100.01821911127648 ,lat: 25.626798369294868},
            {lng: 100.01833584942169 ,lat: 25.62655841731495},
            {lng: 100.01851128816328 ,lat: 25.626627928223243}]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="71">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01782006427607 ,lat: 25.628064270619845},
            {lng: 100.01766987652586 ,lat: 25.628034955716323},
            {lng: 100.01771131628367 ,lat: 25.627919412443248},
            {lng: 100.01786736645721 ,lat: 25.627953271567495}]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="72">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01762755971708 ,lat: 25.628022779134724},
            {lng: 100.01751976417255 ,lat: 25.628020456834868},
            {lng: 100.01751542335933 ,lat: 25.62786372276575},
            {lng: 100.01761080442559 ,lat: 25.62785342834702}]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="73">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01757660236424 ,lat: 25.62770622919185},
            {lng: 100.01761460981722 ,lat: 25.627570877612893},
            {lng: 100.01790978576349 ,lat: 25.627624868194353},
            {lng: 100.01787621900725 ,lat: 25.62778346624253}]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="74">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01900220411581 ,lat: 25.626406669871574},
            {lng: 100.01915936137705 ,lat: 25.62648639001049},
            {lng: 100.0192537205389 ,lat: 25.62633104616064},
            {lng: 100.01918901750248 ,lat: 25.62628842280141},
            {lng: 100.01912644053891 ,lat: 25.626377454919183},
            {lng: 100.01903348097014 ,lat: 25.62633230137191}]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="75">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01890480456558 ,lat: 25.628722645456246},{lng: 100.01895907578378 ,lat: 25.628640177296482},{lng: 100.01915431751226 ,lat: 25.628737809810538},{lng: 100.01911256100814 ,lat: 25.62881823403216},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="76">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01890978742608 ,lat: 25.62842871845397},{lng: 100.01900085098927 ,lat: 25.62829794377152},{lng: 100.01909452220835 ,lat: 25.62833956473206},{lng: 100.01900419436288 ,lat: 25.62847555767315},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="77">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01940933637775 ,lat: 25.628546876423975},{lng: 100.01945019756045 ,lat: 25.628418122797825},{lng: 100.01954770134255 ,lat: 25.62844757993507},{lng: 100.0195746775439 ,lat: 25.628385239045485},{lng: 100.01967891245616 ,lat: 25.62840365553105},{lng: 100.01959815827745 ,lat: 25.628587679038542},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="78">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02073584949473 ,lat: 25.62905313732071},{lng: 100.0208358597837 ,lat: 25.62909225762268},{lng: 100.02088825003761 ,lat: 25.6289796524821},{lng: 100.0207873319166 ,lat: 25.62893867154547},]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="79">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0203485412598 ,lat: 25.62900967393823},{lng: 100.02039702661178 ,lat: 25.628931722926914},{lng: 100.02050510821624 ,lat: 25.628988440754554},{lng: 100.02047748799014 ,lat: 25.62907861176771},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="80">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02047771863985 ,lat: 25.6288619351714},{lng: 100.02052818260458 ,lat: 25.62879662720585},{lng: 100.0206639994485 ,lat: 25.628857206501177},{lng: 100.02061956046386 ,lat: 25.628925680357913},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="81">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01961486133492 ,lat: 25.627696366401615},{lng: 100.01970807980241 ,lat: 25.627586502925507},{lng: 100.01949247036549 ,lat: 25.627443935599285},{lng: 100.01941269531355 ,lat: 25.627519940343777},]"
            :material="[255,241,0,125]"
            :extruded-height="90.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="82">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0190631701664 ,lat: 25.627767450666184},{lng: 100.01919882669372 ,lat: 25.627828068715967},{lng: 100.0193563372026 ,lat: 25.62756339488816},{lng: 100.01922539905568 ,lat: 25.62748936731133},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="83">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01873641575169 ,lat: 25.628982263707382},{lng: 100.01874442316635 ,lat: 25.62891943131556},{lng: 100.01895651269196 ,lat: 25.628938027899274},{lng: 100.01893929615537 ,lat: 25.62900707905185},]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="84">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01861343606163 ,lat: 25.628731018910077},{lng: 100.01865779162787 ,lat: 25.62865506135161},{lng: 100.0188681365025 ,lat: 25.6287538974728},{lng: 100.01889736082052 ,lat: 25.628857629312744},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="85">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02037147542829 ,lat: 25.629311064551366},{lng: 100.0203688741886 ,lat: 25.629222501715336},{lng: 100.02050359294634 ,lat: 25.629228308667333},{lng: 100.02049788889357 ,lat: 25.62932881412791},]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="86">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02037471691 ,lat: 25.629531676900267},{lng: 100.0203853006225 ,lat: 25.629428257990636},{lng: 100.02048978250903 ,lat: 25.62944192442529},{lng: 100.02049015662156 ,lat: 25.629530612811426},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="87">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0211524519803 ,lat: 25.629950109701063},{lng: 100.02108304260793 ,lat: 25.629893472722905},{lng: 100.02113984830964 ,lat: 25.629847964400028},{lng: 100.02121063088676 ,lat: 25.629899789008878},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="88">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02111254228568 ,lat: 25.62981251689972},{lng: 100.02113962599525 ,lat: 25.62966578398319},{lng: 100.02120834407188 ,lat: 25.62966630215803},{lng: 100.02119151552033 ,lat: 25.629810865912035},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="89">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02100395519874 ,lat: 25.62958606039533},{lng: 100.02106427773863 ,lat: 25.62954017856013},{lng: 100.02094977978011 ,lat: 25.62945337672251},{lng: 100.02089255765495 ,lat: 25.62949430660179},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="90">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02133214625884 ,lat: 25.62936128260237},{lng: 100.02133806602616 ,lat: 25.629301720927476},{lng: 100.02152206238469 ,lat: 25.62932953536423},{lng: 100.02150109321465 ,lat: 25.62939317355768},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="91">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02209134162472 ,lat: 25.628369973336525},{lng: 100.02209585550908 ,lat: 25.628235146115827},{lng: 100.02236285268202 ,lat: 25.62822828152996},{lng: 100.02235568141106 ,lat: 25.628359641278475},]"
            :material="[0,255,0,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="92">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02254311753246 ,lat: 25.628568185624196},{lng: 100.02257506450745 ,lat: 25.628469516442507},{lng: 100.02266030192541 ,lat: 25.628488165881983},{lng: 100.02261282142678 ,lat: 25.6285928451058},]"
            :material="[255,241,0,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="93">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02234359477038 ,lat: 25.628715095118732},{lng: 100.02233512876884 ,lat: 25.628593182351985},{lng: 100.02236588007598 ,lat: 25.62859122061816},{lng: 100.0223730671457 ,lat: 25.628711484306063},]"
            :material="[77, 158, 252,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="94">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02226234287087 ,lat: 25.628576816126852},{lng: 100.02225356875402 ,lat: 25.62854062633817},{lng: 100.02233273318413 ,lat: 25.628536041584656},{lng: 100.02233439120849 ,lat: 25.628566684634947},]"
            :material="[255,146,13,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="95">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02186293905409 ,lat: 25.62816880610138},{lng: 100.02180655719317 ,lat: 25.628119228367417},{lng: 100.02187945667481 ,lat: 25.62807153407121},{lng: 100.02192587077758 ,lat: 25.62811379270992},]"
            :material="[77, 158, 252,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="96">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02183455990148 ,lat: 25.628044211517928},{lng: 100.02193118396985 ,lat: 25.62795987875458},{lng: 100.02187775957134 ,lat: 25.627909357360263},{lng: 100.02177611508705 ,lat: 25.62799254073379},]"
            :material="[77, 158, 252,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="97">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01927609539236 ,lat: 25.62889836243071},{lng: 100.01932387082815 ,lat: 25.628789095019496},{lng: 100.01948792596613 ,lat: 25.6288420780983},{lng: 100.01945678998497 ,lat: 25.628948011854305},]"
            :material="[255,146,13,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="98">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01907350549037 ,lat: 25.62878148142117},{lng: 100.0191002531126 ,lat: 25.628708587371253},{lng: 100.01928176660118 ,lat: 25.628759455971974},{lng: 100.01924343296487 ,lat: 25.628855235196372},]"
            :material="[77, 158, 252,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="99">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02175199971214 ,lat: 25.6278668210496},{lng: 100.02182541868439 ,lat: 25.627801142223635},{lng: 100.02186678405664 ,lat: 25.627828929884156},{lng: 100.02177887806656 ,lat: 25.627897966363545},]"
            :material="[77, 158, 252,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="100">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02156043087614 ,lat: 25.627643703192092},{lng: 100.02160991660621 ,lat: 25.627610120817685},{lng: 100.02179594205688 ,lat: 25.62778352351571},{lng: 100.02175200711854 ,lat: 25.627811847296336},]"
            :material="[0,255,0,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="101">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01892838840841 ,lat: 25.627002158660936},{lng: 100.01894458406976 ,lat: 25.6269080086281},{lng: 100.01905192570752 ,lat: 25.626925137834856},{lng: 100.01902819603814 ,lat: 25.627016788427717},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="102">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01923584114307 ,lat: 25.626750573465056},{lng: 100.0192851282983 ,lat: 25.626705808681887},{lng: 100.01938544827208 ,lat: 25.626797298882174},{lng: 100.0193244688089 ,lat: 25.62684984584944},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="103">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02099225034814 ,lat: 25.6274183366301},{lng: 100.0208885867985 ,lat: 25.62732977098626},{lng: 100.02116730796153 ,lat: 25.627060386899615},{lng: 100.02128478473531 ,lat: 25.627193289313862},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="104">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02123994970863 ,lat: 25.62677061002434},{lng: 100.02135701669472 ,lat: 25.626765491272433},{lng: 100.0213339290365 ,lat: 25.62701435263991},{lng: 100.02127545964291 ,lat: 25.626998144935516},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="105">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0206706039152 ,lat: 25.626497941969244},{lng: 100.02066823524785 ,lat: 25.626398309679548},{lng: 100.02088846463718 ,lat: 25.62638811213433},{lng: 100.02091515563896 ,lat: 25.626498834591448},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="106">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01874579018902 ,lat: 25.62647414632348},{lng: 100.01862701608717 ,lat: 25.62642754902344},{lng: 100.01881445711936 ,lat: 25.626127530030967},{lng: 100.01893005247516 ,lat: 25.626164002928398},]"
            :material="[197,48,55,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="107">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01789909232983 ,lat: 25.62634665237515},{lng: 100.01794407906728 ,lat: 25.626265738457892},{lng: 100.01837038815187 ,lat: 25.626404559377804},{lng: 100.0183278990687 ,lat: 25.626493405969992},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="108">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0187483352501 ,lat: 25.62597817467186},{lng: 100.01880769639462 ,lat: 25.625899745144928},{lng: 100.01898560659838 ,lat: 25.62598576700107},{lng: 100.01893521596799 ,lat: 25.626074979055563},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="109">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01849793442231 ,lat: 25.62576132961838},{lng: 100.01856663550952 ,lat: 25.62569509546339},{lng: 100.01873356065177 ,lat: 25.62586762627341},{lng: 100.01866352251209 ,lat: 25.62592748307806},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="110">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01949454724604 ,lat: 25.627877533347338},{lng: 100.01952564981904 ,lat: 25.627811062012693},{lng: 100.0196895905074 ,lat: 25.627889358689277},{lng: 100.01964994898589 ,lat: 25.627938692534876},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="111">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01989763486658 ,lat: 25.62791814491999},{lng: 100.01995983890733 ,lat: 25.6278480394131},{lng: 100.02012428703601 ,lat: 25.627923737381597},{lng: 100.02008117488171 ,lat: 25.628007011846783},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="112">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01978437181192 ,lat: 25.628192237183068},{lng: 100.01973059319201 ,lat: 25.628137261637487},{lng: 100.01981391495181 ,lat: 25.628067292174066},{lng: 100.01988450575837 ,lat: 25.628114856947946},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="113">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01834047841571 ,lat: 25.628563207553242},{lng: 100.01835819661754 ,lat: 25.628447848137277},{lng: 100.01854933915227 ,lat: 25.628484556323656},{lng: 100.0185266469752 ,lat: 25.628565916905124},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="114">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01830552830003 ,lat: 25.62782786474938},{lng: 100.01835460936258 ,lat: 25.62772392202318},{lng: 100.0185607747047 ,lat: 25.627776828482546},{lng: 100.01849856605213 ,lat: 25.6278982207918},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="115">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01930319275085 ,lat: 25.625933079567783},{lng: 100.01927325203968 ,lat: 25.625765879157697},{lng: 100.01939652960645 ,lat: 25.625759276324693},{lng: 100.01939861661987 ,lat: 25.62592384662641},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="116">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01972005521752 ,lat: 25.627623752189145},{lng: 100.01985023814298 ,lat: 25.627541996029713},{lng: 100.0199995896747 ,lat: 25.62771341351481},{lng: 100.01988474999317 ,lat: 25.627774813158986},]"
            :material="[0,255,0,125]"
            :extruded-height="90.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="117">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01968613585014 ,lat: 25.628027167186396},{lng: 100.01945200189016 ,lat: 25.627931168731852},{lng: 100.01951009377869 ,lat: 25.627851336643243},{lng: 100.0197437522829 ,lat: 25.627941615642275},]"
            :material="[77, 158, 252,125]"
            :extruded-height="90.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="118">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01937590943793 ,lat: 25.627869899259288},{lng: 100.01924539337908 ,lat: 25.6277989561292},{lng: 100.01934325114914 ,lat: 25.62758949274945},{lng: 100.01949365269307 ,lat: 25.627655852613504},]"
            :material="[0,255,0,125]"
            :extruded-height="90.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="119">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01986275366947 ,lat: 25.628036596681724},{lng: 100.0198129487705 ,lat: 25.627968925168254},{lng: 100.01990869610525 ,lat: 25.627884889508536},{lng: 100.01999428799107 ,lat: 25.62794362493479},]"
            :material="[77, 158, 252,125]"
            :extruded-height="90.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="120">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01936661981699 ,lat: 25.628792863302863},{lng: 100.01940891085688 ,lat: 25.628553197320205},{lng: 100.01950527365025 ,lat: 25.62856405413905},{lng: 100.01944152506974 ,lat: 25.628818391276013},]"
            :material="[77, 158, 252,125]"
            :extruded-height="90.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="121">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02106333879459 ,lat: 25.628476707043305},{lng: 100.02124363355574 ,lat: 25.628607902764035},]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="122">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01890760540078 ,lat: 25.627300659490626},{lng: 100.0190099569331 ,lat: 25.627564728199168},{lng: 100.0190334735552 ,lat: 25.6273057944935},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="123">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01891215449272 ,lat: 25.627327394995387},{lng: 100.01900952607733 ,lat: 25.627372758517673},{lng: 100.01910129193357 ,lat: 25.627204634205675},{lng: 100.01900356043724 ,lat: 25.62715985272802},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="124">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02004333090925 ,lat: 25.62766604205391},{lng: 100.0201354460604 ,lat: 25.627824426110365},{lng: 100.02021571632125 ,lat: 25.62778676642423},{lng: 100.02013677564084 ,lat: 25.62763404616833},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="125">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01860938301878 ,lat: 25.6280622958808},{lng: 100.01862292559589 ,lat: 25.628200859843883},{lng: 100.01834502874478 ,lat: 25.62817803891119},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="126">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0186574116369 ,lat: 25.628013138540638},{lng: 100.01873033546758 ,lat: 25.628039613363555},{lng: 100.0187067862497 ,lat: 25.62823722183029},{lng: 100.0186275263123 ,lat: 25.6282239265745},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="127">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01836014967257 ,lat: 25.627896556327176},{lng: 100.01855899480634 ,lat: 25.62778897199589},{lng: 100.01858084225944 ,lat: 25.62794690055027},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="128">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01880544278775 ,lat: 25.628225651667808},{lng: 100.01882666802582 ,lat: 25.62809389342756},{lng: 100.018919990694 ,lat: 25.628129980237755},{lng: 100.01887915588472 ,lat: 25.628248276532197},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="129">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02139004236753 ,lat: 25.629098468866253},{lng: 100.02132507176837 ,lat: 25.629124973767254},{lng: 100.02138492661298 ,lat: 25.629236675922908},{lng: 100.02145257578103 ,lat: 25.629203858027747},]"
            :material="[255,241,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="130">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02134782465762 ,lat: 25.6298380711304},{lng: 100.021486526959 ,lat: 25.62993045699422},{lng: 100.02160399557441 ,lat: 25.629811592413695},{lng: 100.02154610850161 ,lat: 25.629778852219218},{lng: 100.02150693502098 ,lat: 25.629818729454488},{lng: 100.02141872997902 ,lat: 25.629755013042598},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="131">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02111553280373 ,lat: 25.62937826986109},{lng: 100.02115160381868 ,lat: 25.629416120886894},{lng: 100.02109465354754 ,lat: 25.62948116960704},{lng: 100.02104853491025 ,lat: 25.629435308499232},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="132">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01988419400557 ,lat: 25.62922137522376},{lng: 100.01988851792528 ,lat: 25.629287542634767},{lng: 100.02000975064603 ,lat: 25.629297354038002},{lng: 100.02001082952606 ,lat: 25.629231809731447},]"
            :material="[77, 158, 252,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="133">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01967556491473 ,lat: 25.62922311248465},{lng: 100.01964519276571 ,lat: 25.6292815184465},{lng: 100.0197839370196 ,lat: 25.62934056421581},{lng: 100.01982881886545 ,lat: 25.629269992788174},]"
            :material="[77, 158, 252,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="134">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01938877156039 ,lat: 25.629167704596913},{lng: 100.01942476146608 ,lat: 25.629265893044984},{lng: 100.01959960112126 ,lat: 25.629139499021285},{lng: 100.01964001327471 ,lat: 25.62922897767747},]"
            :material="[255,241,0,125]"
            :extruded-height="40.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="135">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02028889422596 ,lat: 25.628068483889933},{lng: 100.02034403294833 ,lat: 25.627976553254953},{lng: 100.02048122367582 ,lat: 25.62805762772538},{lng: 100.02041535205382 ,lat: 25.62813393351058},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity :description="136">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01986660417857 ,lat: 25.62894407636982},{lng: 100.01988044090258 ,lat: 25.628791940486035},{lng: 100.01999792902737 ,lat: 25.628775446612558},{lng: 100.01995952989175 ,lat: 25.628947461220555},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="137">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0195141183545 ,lat: 25.628776531521222},{lng: 100.01954687218687 ,lat: 25.628696089312907},{lng: 100.01973197764394 ,lat: 25.62872913855988},{lng: 100.01973224380913 ,lat: 25.62881223732452},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="138">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01976368093088 ,lat: 25.62870384532615},{lng: 100.01976995927424 ,lat: 25.628636762186417},{lng: 100.01992414223434 ,lat: 25.628629067176245},{lng: 100.0199256403171 ,lat: 25.62870310827679},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="139">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01976462380165 ,lat: 25.628964696889316},{lng: 100.01980170845091 ,lat: 25.628800931242335},{lng: 100.01987125287124 ,lat: 25.628808771202273},{lng: 100.01984635423072 ,lat: 25.628971655024507},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="140">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01961699821219 ,lat: 25.6286048326829},{lng: 100.01964227183005 ,lat: 25.628555501584717},{lng: 100.01972985970916 ,lat: 25.628576925222326},{lng: 100.0197111159949 ,lat: 25.628626318066843},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="141">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0199580381867 ,lat: 25.628178907673234},{lng: 100.02003818906378 ,lat: 25.62809577890912},{lng: 100.02022471967554 ,lat: 25.62820371539191},{lng: 100.02014832579069 ,lat: 25.62829016166524},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="142">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.0201365658448 ,lat: 25.627994636827374},{lng: 100.0201832372697 ,lat: 25.627908824398034},{lng: 100.02030150213095 ,lat: 25.627959969019372},{lng: 100.02022866352 ,lat: 25.628051622984785},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="143">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02053679604161 ,lat: 25.628658912511273},{lng: 100.02061859802353 ,lat: 25.628552703756615},{lng: 100.02089308921848 ,lat: 25.628699875941845},{lng: 100.02083844101882 ,lat: 25.62879814270043},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="144">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02095691704773 ,lat: 25.628685629064222},{lng: 100.02100207703332 ,lat: 25.628601933134536},{lng: 100.02113079030771 ,lat: 25.628657940960586},{lng: 100.02106848622994 ,lat: 25.62875831814379},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="145">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01874679392064 ,lat: 25.628425253966125},{lng: 100.01880222391262 ,lat: 25.62825990116316},{lng: 100.01889040956307 ,lat: 25.62830454847633},{lng: 100.01883081410877 ,lat: 25.628437001673145},]"
            :material="[0,255,0,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="146">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01922781295359 ,lat: 25.628669209170617},{lng: 100.01925160603643 ,lat: 25.628534505267943},{lng: 100.01936936761807 ,lat: 25.628546376700008},{lng: 100.01931843142113 ,lat: 25.628694290340363},]"
            :material="[77, 158, 252,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="147">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01940568748674 ,lat: 25.628945473338767},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="148">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01804050752114 ,lat: 25.629288530626148},{lng: 100.01789058473979 ,lat: 25.629208668288445},{lng: 100.01803993778383 ,lat: 25.629048788635885},{lng: 100.0181604415584 ,lat: 25.6291219049362},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="149">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02002859273898 ,lat: 25.628365029888702},{lng: 100.01994831844318 ,lat: 25.628536268497466},{lng: 100.02005725131444 ,lat: 25.62856407008875},{lng: 100.02011985969516 ,lat: 25.628403131667888},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="150">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02104295044283 ,lat: 25.629716549600577},{lng: 100.02108403883479 ,lat: 25.62968422478739},{lng: 100.02100791607883 ,lat: 25.629610575051448},{lng: 100.0209497496363 ,lat: 25.6296191363573},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="151">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.02047894396893 ,lat: 25.628065494359618},{lng: 100.02056926317393 ,lat: 25.628169200272612},{lng: 100.020610377594 ,lat: 25.628143441659265},{lng: 100.02057916657687 ,lat: 25.628012856731438},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="152">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01998962261568 ,lat: 25.628428671522546},{lng: 100.02000760981937 ,lat: 25.62847526807511},{lng: 100.02007506474385 ,lat: 25.628466576129572},{lng: 100.02008141909033 ,lat: 25.628435096070724},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="153">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.019164702526 ,lat: 25.62810456148836},{lng: 100.0192769133296 ,lat: 25.628165211977993},{lng: 100.01930882098404 ,lat: 25.62808604192061},{lng: 100.019199411828 ,lat: 25.628030487936165},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-entity description="154">
        <vc-graphics-polygon
            :hierarchy="[{lng: 100.01818305129328 ,lat: 25.62841001161301},{lng: 100.01825949722155 ,lat: 25.62840585276395},{lng: 100.01829849194381 ,lat: 25.628305282507274},{lng: 100.01820742789374 ,lat: 25.628293043966107},]"
            :material="[255,146,13,125]"
            :extruded-height="70.0"
        ></vc-graphics-polygon>
      </vc-entity>
      <vc-selection-indicator ref="selectionIndicator" @pickEvt="pickEvt"></vc-selection-indicator>
      <vc-measurements
          @draw-evt="drawEvt"
          @active-evt="activeEvt"
          @editor-evt="editorEvt"
          @mouse-evt="mouseEvt"
          ref="measurementsRef"
          position="bottom-left"
          :mainFabOpts="measurementFabOptions"
          :offset="[20, 80]"
      >
      </vc-measurements>
      <vc-datasource-custom name="epicenter" :show="layerControl.showEpicenter">
        <vc-entity
            :position="[item.longitude,item.latitude, 0]"
            description="epicenter"
            :id="'epicenter_'+index.toString()"
            v-for="(item,index) in earthquakeInfoList"
        >
          <vc-graphics-point ref="point1" color="red" :pixelSize="2*item.magnitude"></vc-graphics-point>
        </vc-entity>
      </vc-datasource-custom>
      <vc-datasource-custom name="intensity" :show="layerControl.showIntensity">
        <vc-entity
            :position="[earthquakeInfoList[selectedEarthquakeIndex].longitude,earthquakeInfoList[selectedEarthquakeIndex].latitude,0]"
            :description="'intensity:'+item.intensity"
            :id="'intensity_'+index"
            v-for="(item,index) in earthquakeInfoList[selectedEarthquakeIndex].intensityLineList"
        >
          <vc-graphics-ellipse
              :semiMinorAxis="item.longRadius*1000"
              :semiMajorAxis="item.shortRadius*1000"
              :material="[255, (10-item.intensity)*30, (10-item.intensity)*30, 100]"
              :rotation="item.angle"
              :fill="true">
          </vc-graphics-ellipse>
        </vc-entity>
      </vc-datasource-custom>
<!--      <vc-terrain-provider-tianditu token="fd7029d3dff756b437af91d68aadc6bf"></vc-terrain-provider-tianditu>-->
      <vc-layer-imagery :alpha="imageryConfig.alpha" :brightness="imageryConfig.brightness" :contrast="imageryConfig.contrast" :sortOrder="20">
        <vc-imagery-provider-tianditu mapStyle="eva_w" token="de232c2bf878c7a7928afde78e339913"></vc-imagery-provider-tianditu>
      </vc-layer-imagery>
      <vc-layer-imagery :alpha="imageryConfig.alpha" :brightness="imageryConfig.brightness" :contrast="imageryConfig.contrast" :sortOrder="10">
        <vc-imagery-provider-tianditu :mapStyle="imageryConfig.mapStyle" token="de232c2bf878c7a7928afde78e339913" ref="provider"></vc-imagery-provider-tianditu>
      </vc-layer-imagery>
      <vc-navigation :offset="navigationConfig.offset" :otherOpts="navigationConfig.otherOpts"></vc-navigation>
      <vc-ajax-bar></vc-ajax-bar>
      <!-- hyc：增加图标位置 -->
<!--      <vc-collection-primitive-->
<!--        :show="layerControl.showHospital"-->
<!--      >-->
<!--        <vc-collection-billboard-->
<!--          :billboards="hospitalBillboards"-->
<!--        ></vc-collection-billboard>-->
<!--      </vc-collection-primitive>-->
      <vc-datasource-custom
          :show="layerControl.showHospital"
          name="hospitalList"
          :entities="hospitalBillboards"
          @clusterEvent="onHospitalClusterEvent"
          @ready="onHospitalReady"
      >
      </vc-datasource-custom>
      <!--        hyc：增加椭圆显示位置-->
      <vc-entity :position="[longTemp, latiTemp]" description="area">
        <vc-graphics-ellipse :semiMinorAxis="50.0" :semiMajorAxis="50.0" :material="[255, 0, 0, 125]"></vc-graphics-ellipse>
        <vc-graphics-label text="start point" font="20px sans-serif" :pixelOffset="[0, 20]" fillColor="red"></vc-graphics-label>
      </vc-entity>
      <!--hyc:消防队位置-->
      <vc-datasource-custom
          :show="layerControl.showFireCenter"
          name="fireCenterList"
          :entities="fireCenterBillboards"
          @clusterEvent="onFireCenterClusterEvent"
          @ready="onFireCenterReady"
          @mouseout="onMouseout"
          @mouseover="onMouseover"
      >
      </vc-datasource-custom>
    </vc-viewer>
  </el-row>
</template>

<script>
import DetailBox from "../components/DetailBox";
import EarthquakeSelect from "../components/EarthquakeSelect";
import AddEarthquake from "../components/AddEarthquake";
import EstimateEarthquake from "../components/EstimateEarthquake";
import {cartesianToLnglat, gcj2wgs, lnglatArrToCartesianArr, wgs2gcj} from "../assets/coordinateConversion";
export default {
  name: "Cesium",
  components: {
    DetailBox,
    EarthquakeSelect,
    AddEarthquake,
    EstimateEarthquake
  },
  data() {
    return {
      DistrictSum:10,
      activeCalculateWeight:['1'],
      DistributionSum:1000,
      cesiumLoading:true,
      fireCenterLoading:false,
      visibleRoad:false,
      radioRoad:"1",
      Search:this.Search,
      Check:this.Check,
      //data
      fireWeight:[],
      hospitalBillboards:[],
      fireCenterBillboards:[],
      hospitalList: [],
      //earthquakeInfo
      earthquakeInfoList:[{
        earthquakeId:1,
        earthquakeName:'云南大理地震',
        magnitude:6.1,
        highIntensity:7,
        longitude:25.727,
        latitude:100.008,
        earthquakeTime:'2021-12-02 10:24:07',
        intensityLineList:[{
          lineId:1,
          longRadius:11.143207166465402,
          shortRadius:6.045067370310756,
          intensity:5,
          angle:-20,
          earthquakeId:1
        }]
      }],
      selectedEarthquakeIndex:0,
      //detailBox
      detailBox:{
        showDetail: false,
        detailClass: 0,
        detailIndex: 0,
        quickEarthquakeIndex:0,
        showButton: true
      },
      //measure
      measurementFabOptions: {
        direction: 'right'
      },
      //viewer
      viewerConfig:{
        animation: false,
        timeline: false,
        baseLayerPicker: false,
        fullscreenButton: false,
        infoBox: false,
        showCredit: false,
        fullscreenElement: document.body,
      },
      //imagery-provider
      imageryConfig:{
        alpha:1,
        brightness:1,
        contrast:1,
        mapStyle:'img_w',
        options: [
          {value: 'img_c', label: 'Global image map service (lng and lat)'},
          {value: 'img_w', label: 'Global image map service (Mercator)'},
          {value: 'vec_c', label: 'Global vector map service (lng and lat)'},
          {value: 'vec_w', label: 'Global vector map service (Mercator)'},
        ],
      },
      //navigation
      navigationConfig:{
        offset: [10, 25],
        otherOpts: {
          offset: [0, 32],
          position: 'bottom-right'
        },
      },
      //layerControl
      layerControl:{
        visible:false,
        showIntensity: false,
        showEpicenter: false,
        showHospital: false,
        showFireCenter: false,
        showModel:true,
      },
      // hyc2
      num: 0,
      SuccessClick: false,
      startLon: 0.0,
      startLat: 0.0,
      startHei: 0.0,
      longTemp: 0.0,
      latiTemp: 0.0,
      heiTemp: 0.0,
      endLon: 0.0,
      endLat: 0.0,
      endHei: 0.0,

      longitudeArray:[],
      latitudeArray:[],
      isDraw:false,
    }
  },
  watch: {
    timeline(val) {
      this.navigationConfig.otherOpts.offset = val ? [0, 30] : this.fullscreenButton ? [30, 5] : [0, 5]
    },
    fullscreenButton(val) {
      if (!this.timeline && !val) {
        this.navigationConfig.otherOpts.offset = [0, 5]
      } else if (!this.timeline && val) {
        this.navigationConfig.otherOpts.offset = [30, 5]
      }
    }
  },
  created() {
    this.getEarthquakeList();
  },
  mounted() {
    this.$refs.vcViewer.createPromise.then(({ Cesium, viewer }) => {
      viewer.scene.globe.depthTestAgainstTerrain = false;
    });
  },
  methods: {
    onReadyPromise(tileset, viewer) {
      const cartographic = Cesium.Cartographic.fromCartesian(tileset.boundingSphere.center)
      const surface = Cesium.Cartesian3.fromRadians(cartographic.longitude, cartographic.latitude, cartographic.height)
      const offset = Cesium.Cartesian3.fromRadians(cartographic.longitude-0.000009, cartographic.latitude+0.000004, 0)
      const translation = Cesium.Cartesian3.subtract(offset, surface, new Cesium.Cartesian3())
      tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation)
      viewer.zoomTo(tileset)
    },
    onClicked(e) {
      let cartographic = Cesium.Cartographic.fromCartesian(e.surfacePosition);
      console.log('lng:',Cesium.Math.toDegrees(cartographic.longitude),',lat:', Cesium.Math.toDegrees(cartographic.latitude))
      if(this.isDraw)
      {
        this.longitudeArray.push(Cesium.Math.toDegrees(cartographic.longitude))
        this.latitudeArray.push(Cesium.Math.toDegrees(cartographic.latitude))
        console.log('point added')
      }
    },
    startDraw(){
      this.isDraw=true
      this.longitudeArray=[]
      this.latitudeArray=[]
    },
    stopDraw(){
      this.isDraw=false
      let res=
          '      <vc-entity :description="1">\n' +
          '        <vc-graphics-polygon\n' +
          '            :hierarchy="['
      for(let i=0;i<this.longitudeArray.length;i++)
      {
        res+='{lng: '+this.longitudeArray[i]+' ,lat: '+this.latitudeArray[i]+'},'
      }
      res+=']"\n'+
          '            :material="[0,255,0,125]"\n' +
          '            :extruded-height="70.0"\n' +
          '        ></vc-graphics-polygon>\n' +
          '      </vc-entity>'
      console.log(res)
    },
    allTilesLoaded(e) {
      console.log('allTilesLoaded')
    },
    handleChangeWeight(val) {
      console.log(val);
    },
    reGetCalculateWeight(){
      this.$message.warning("calculating")
      this.fireWeight=[];
      this.fireCenterBillboards=[];
      this.getFireCenters();
    },
    //update earthquake list
    updateEarthquakeList(list){
      this.earthquakeInfoList=list
      this.getHospitals();
    },
    //get earthquake list
    getEarthquakeList(){
      let that=this;
      that.$axios.get("earthquakeInfo/getAllEarthquake")
          .then(res=>{
            that.earthquakeInfoList=res.data;
            that.selectedEarthquakeIndex=4;
            that.getHospitals();
            // that.getFireCenters();
          })
    },
    //change selected earthquake by index
    selectEarthquakeIndex(index){
      this.selectedEarthquakeIndex=index;
      this.getHospitals();
    },
    //change location
    cameraTo(lat,lon,height){
      let viewer=this.$refs.vcViewer.getCesiumObject();
      viewer.camera.flyTo(
          {
            destination : Cesium.Cartesian3.fromDegrees(lat,lon,height),
            orientation : {
              heading : Cesium.Math.toRadians(0.0),
              pitch : Cesium.Math.toRadians(-90.0),
              roll : 0.0
            }
          }
      )
    },
    //event when mouse pick an entity or a position
    pickEvt(e){
      this.layerControl.visible=false
      try{
        // console.log('pickEvt',e)
        if(e._id==='__Vc__Pick__Location__')
        {
          let cartographic = Cesium.Cartographic.fromCartesian(e._position._value);
          console.log('经纬度',Cesium.Math.toDegrees(cartographic.longitude),',',Cesium.Math.toDegrees(cartographic.latitude),cartographic.height)
          if(this.num!==0)
          {
            let cartographic = Cesium.Cartographic.fromCartesian(e._position._value);
            this.longTemp = Cesium.Math.toDegrees(cartographic.longitude);
            this.latiTemp = Cesium.Math.toDegrees(cartographic.latitude);
            this.heiTemp = cartographic.height;
            this.num=0;
          }
          else
          {
            this.visibleRoad = false;
          }
        }
        let kind=e.id.split("_")[0]
        let index=0
        if(kind==='epicenter')
        {
          index=parseInt(e.id.split("_")[1])
          this.detailBox.showButton=true
          this.detailBox.showDetail=true
          this.detailBox.detailClass=1
          this.detailBox.detailIndex=index
          this.detailBox.quickEarthquakeIndex=index
        }
        else if(kind==='hospital')
        {
          index=parseInt(e.id.split("_")[1])
          this.detailBox.showButton=false
          this.detailBox.showDetail=true
          this.detailBox.detailClass=2
          this.detailBox.detailIndex=index
          this.detailBox.quickEarthquakeIndex=index
        }
        else if(kind==='fireCenter')
        {
          index=parseInt(e.id.split("_")[1])
          this.detailBox.showButton=false
          this.detailBox.showDetail=true
          this.detailBox.detailClass=3
          this.detailBox.detailIndex=index
        }
        else if(kind==='intensity')
        {
          index=parseInt(e.id.split("_")[1])
          this.detailBox.showButton=false
          this.detailBox.showDetail=true
          this.detailBox.detailClass=4
          this.detailBox.detailIndex=index
        }
        else
        {
          this.detailBox.showDetail=false
        }
      }
      catch (err) {
        this.detailBox.showDetail=false
      }
    },
    onViewerReady({ Cesium, viewer }) {
      // hyc
      this.cesiumLoading=false;
    },
    getHospitals(){
      // hyc
      let that = this;
      that.hospitalBillboards=[];
      this.$axios.get("/findHospitalNearby?earthquakeId="+that.earthquakeInfoList[that.selectedEarthquakeIndex].earthquakeId).then((res) => {
        this.hospitalList = res.data
        for (let i = 0; i < res.data.length; i++) {
          let hospitalBillboard = {};
          hospitalBillboard.position = {
            lng: res.data[i].lon,
            lat: res.data[i].lat,
          };
          hospitalBillboard.billboard = {
            id: 'hospital_' + i,
            image: "https://file.peteralbus.com/assets/cesium/img/Hospital.png",
            scale: 0.1
          }
          hospitalBillboard.id='hospital_' + i
          that.hospitalBillboards.push(hospitalBillboard);
        }
      });
    },
    getFireCenters(){
      // hyc
      this.fireWeight=[];
      this.fireCenterBillboards=[];
      let that = this;
      this.fireCenterLoading=true;
      this.$axios.get("/findFireCenterNearby?earthquakeId="+that.earthquakeInfoList[that.selectedEarthquakeIndex].earthquakeId).then((res) => {
        let sum=0;
        for(let i=0; i<res.data.length; i++){
          if(i>=that.DistrictSum){
            break;
          }
          let billboard={};
          billboard.position={
            lng:res.data[i].fireLon,
            lat:res.data[i].fireLat,
          }
          billboard.billboard={
            image: "https://file.peteralbus.com/assets/cesium/img/fireCenter.png",
            scale: 0.1,
            weight: 1/(1-res.data[i].fireCenterWeight),
            pixelOffset:{x: 0, y: -45}
          }
          billboard.id=
          sum+=billboard.billboard.weight;
          that.fireCenterBillboards.push(billboard);
        }
        for(let i=0;i<that.fireCenterBillboards.length;i++){
          let fireWeight1={};
          fireWeight1.position=that.fireCenterBillboards[i].position;
          that.fireCenterBillboards[i].label={
            text:"所要分配的物资数量为:"+Math.floor((that.fireCenterBillboards[i].billboard.weight/sum)*this.DistributionSum).toString()+"个"
          }
          that.fireCenterBillboards[i].id="fireCenter_"+Math.floor((that.fireCenterBillboards[i].billboard.weight/sum)*this.DistributionSum).toString()+"_"+i;
            // fireWeight1.text="所要分配的物资数量为:"+Math.floor((that.fireCenterBillboards[i].billboard.weight/sum)*this.DistributionSum).toString()+"个";
            // that.fireWeight.push(fireWeight1);
        }
        that.fireCenterLoading=false
        that.layerControl.visible=false
        that.$message.success('物资分配计算完成')
      })
      .catch(()=>{
        that.fireCenterLoading=false
        that.$message.error('物资分配计算失败')
      });
    },
    stopPositionRoad(){
      this.num=0;
      this.longTemp=0.0;
      this.latiTemp=0.0;
      this.$message.error("结束路径规划,如想要开启路径规划功能，请重新选点");
      this.visibleRoad=!this.visibleRoad;
    },
    selectPositionRoad(){
      this.num++;
      this.$message.success("现在可以开始选取救援点啦~");
    },
    getPositionRoad(viewer, event) {
      console.log("现在点击的坐标经纬度以及高度为:",this.longTemp,this.latiTemp,this.heiTemp,"以及现在num的值为",this.num)
      console.log("我们现在点击的坐标",this.radioRoad)
      let longitude = this.longTemp;
      let latitude = this.latiTemp;
      let height = this.heiTemp;
      let that = this;
      if (longitude!=0) {
        that.startLon = longitude;
        that.startLat = latitude;
        that.startHei = height;
      }
      else {
        that.$message.error("您还没有选取点，请点击屏幕进行选点");
        return;
      }
      that.$message.success("开始路径规划！");
      //起点：经度："+this.startLon +"纬度："+this.startLat+"高度："+this.startHei
      let start = {
        lng: this.startLon,
        lat: this.startLat,
        hei: this.startHei,
      };
      that.$axios
        .post("/calculateDistance", that.$qs.stringify(start))
        .then((res) => {
          that.endLat = res.data.endLat;
          that.endLon = res.data.endLon;
          let start = {
            longitude: this.startLon,
            latitude: this.startLat,
            height: this.startHei,
          };
          let end = {
            longitude: that.endLon,
            latitude: that.endLat,
            height: that.endHei,
          };
          that.howRes(start, end); //调用this.howRes
        });
    },
    howRes(start, end) {
      if (!start || !end) return;
      let startP = cartesianToLnglat(start, true);
      let endP = cartesianToLnglat(end, true);
      this.searchRoute([startP[0], startP[1]], [endP[0], endP[1]]);
    },
    searchRoute(startP, endP) {
      startP = wgs2gcj(startP);
      endP = wgs2gcj(endP);
      let that = this;
      let travelWay;
      if(this.radioRoad=="1"){
        travelWay="/v3/direction/driving";
      }
      if(this.radioRoad=="2"){
        travelWay="/v3/direction/walking"
      }
      if(this.radioRoad=="3"){
        travelWay="/v4/direction/bicycling"
      }
      this.$axios
          .get("https://restapi.amap.com"+travelWay, {
            params: {
              output: "json",
              extensions: "all",
              key: "e21feddaeef263e2506376a2ddbb994e", // https://lbs.amap.com/api/webservice/guide/api/direction
              origin: startP[0] + "," + startP[1],
              destination: endP[0] + "," + endP[1],
              strategy: 11 || 10,
            },
          })
          .then((res) => {
            console.log("路径规划结果：", res.data);
            let steps;
            if(this.radioRoad==3)
              steps = res.data.data.paths[0].steps;
            else if(this.radioRoad==1 ||this.radioRoad==2)
              steps = res.data.route.paths[0].steps;
            let arr = [];
            for (let i = 0; i < steps.length; i++) {
              let item = steps[i];
              let positionStr = item.polyline;
              let strArr = positionStr.split(";");
              for (let z = 0; z < strArr.length; z++) {
                let item2 = strArr[z];
                let strArr2 = item2.split(",");
                let p = gcj2wgs(strArr2);
                arr.push(p);
              }
            }
            let cartesianArr = lnglatArrToCartesianArr(arr);
            let viewer=this.$refs.vcViewer.getCesiumObject();
            let colorTraffic;
            if(this.radioRoad==1){
              colorTraffic=Cesium.Color.RED.withAlpha(0.9);
            }
            else if(this.radioRoad==2){
              colorTraffic=Cesium.Color.BLUE.withAlpha(1);
            }
            else{
              colorTraffic=Cesium.Color.YELLOW.withAlpha(1);
            }
            let line = viewer.entities.add({
              polyline: {
                positions: cartesianArr,
                clampToGround: true,
                material: colorTraffic,
                width: 5,
              },
            });
            this.moveOnRoute(line);
          });
    },
    moveOnRoute(lineEntity) {
      let viewer=this.$refs.vcViewer.getCesiumObject();
      let carModel = null;
      if (!lineEntity) return;
      let positions = lineEntity.polyline.positions.getValue();
      if (!positions) return;
      let allDis = 0;
      for (let index = 0; index < positions.length - 1; index++) {
        let distance = Cesium.Cartesian3.distance(positions[index],positions[index + 1]);
        allDis += distance;
      }
      let playTime = 100;
      let v = allDis / playTime;
      let startTime = viewer.clock.currentTime;
      let endTime = Cesium.JulianDate.addSeconds(startTime,playTime,new Cesium.JulianDate());
      let property = new Cesium.SampledPositionProperty();
      let t = 0;
      for (let i = 1; i < positions.length; i++) {
        if (i === 1) {
          property.addSample(startTime, positions[0]);
        }
        let dis = Cesium.Cartesian3.distance(positions[i], positions[i - 1]);
        let time = dis / v + t;
        let julianDate = Cesium.JulianDate.addSeconds(
            startTime,
            time,
            new Cesium.JulianDate()
        );
        property.addSample(julianDate, positions[i]);
        t += dis / v;
      }
      // if (carModel) {
      //   viewer.entities.remove(carModel);
      //   carModel = null;
      // }
      let modelUrl;
      let modelSize;
      if(this.radioRoad==1){
        modelSize=5;
        modelUrl="https://file.peteralbus.com/assets/cesium/glb/GroundVehicle.glb";
      }
      else if(this.radioRoad==2){
        modelSize=250;
        modelUrl="https://file.peteralbus.com/assets/cesium/glb/Astronaut.glb";
      }
      else if(this.radioRoad==3){
        modelSize=50;
        modelUrl="https://file.peteralbus.com/assets/cesium/glb/Motorcycle.glb"
      }
      carModel = viewer.entities.add({
        position: property,
        orientation: new Cesium.VelocityOrientationProperty(property),
        model: {
          uri: modelUrl,
          scale: modelSize,
        },
      });
      viewer.clock.currentTime = startTime;
      viewer.clock.multiplier = 1;
      viewer.clock.shouldAnimate = true;
      viewer.clock.stopTime = endTime;
    },

    onHospitalReady ({ Cesium, viewer, cesiumObject }) {
      window.cesiumObject = cesiumObject

      //开启聚合功能
      cesiumObject.clustering.enabled = true
      cesiumObject.clustering.pixelRange = 30
      cesiumObject.clustering.minimumClusterSize = 5
    },
    onHospitalClusterEvent(clusteredEntities, cluster){
      cluster.billboard.show = !0
      cluster.label.show = !1
      cluster.billboard.id = cluster.label.id
      cluster.billboard.verticalOrigin = Cesium.VerticalOrigin.CENTER
      clusteredEntities.length >= 300
          ? (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/300+.png')
          : clusteredEntities.length >= 150
              ? (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/150+.png')
              : clusteredEntities.length >= 90
                  ? (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/90+.png')
                  : clusteredEntities.length >= 30
                      ? (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/30+.png')
                      : clusteredEntities.length > 10
                          ? (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/10+.png')
                          : (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/' + clusteredEntities.length + '.png')
    },
    onFireCenterReady ({ Cesium, viewer, cesiumObject }) {
      window.cesiumObject = cesiumObject

      //开启聚合功能
      cesiumObject.clustering.enabled = false
      cesiumObject.clustering.pixelRange = 30
      cesiumObject.clustering.minimumClusterSize = 10
    },
    onFireCenterClusterEvent(clusteredEntities, cluster){
      cluster.billboard.show = !0
      cluster.label.show = !1
      cluster.billboard.id = cluster.label.id
      cluster.billboard.verticalOrigin = Cesium.VerticalOrigin.CENTER
      clusteredEntities.length >= 300
          ? (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/300+.png')
          : clusteredEntities.length >= 150
              ? (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/150+.png')
              : clusteredEntities.length >= 90
                  ? (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/90+.png')
                  : clusteredEntities.length >= 30
                      ? (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/30+.png')
                      : clusteredEntities.length > 10
                          ? (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/10+.png')
                          : (cluster.billboard.image = 'https://file.peteralbus.com/assets/cesium/img/clusters/' + clusteredEntities.length + '.png')
    },
    //物资分配特效
    onMouseover(e){
      if (e.cesiumObject instanceof Cesium.Label) {
        this.scale = 1.5 // or e.cesiumObject.scale = 1.5
        e.pickedFeature.primitive.scale = 1.5
      } else if (e.cesiumObject instanceof Cesium.LabelCollection) {
        e.pickedFeature.primitive.scale = 1.5
      }
    },

    onMouseout(e){
      if (e.cesiumObject instanceof Cesium.Label) {
        this.scale = 1 // or e.cesiumObject.scale = 1
      } else if (e.cesiumObject instanceof Cesium.LabelCollection) {
        e.pickedFeature.primitive.scale = 1
      }
    },

    //量算工具
    drawEvt(e, viewer) {
      console.log(e)
      const restoreCursor = getComputedStyle(viewer.canvas).cursor
      if (e.finished) {
        this.drawing = false
        if (e.type === 'move') {
          viewer.canvas.setAttribute('style', `cursor: ${this.restoreCursorMove}`)
        }
      } else {
        this.drawing = true
        if (e.type === 'move') {
          viewer.canvas.setAttribute('style', 'cursor: move')
        }
        if (e.type === 'new') {
          viewer.canvas.setAttribute('style', 'cursor: crosshair')
        }
      }
    },
    measureEvt(e, viewer) {
      console.log(e)
      const restoreCursor = getComputedStyle(viewer.canvas).cursor
      if (e.finished) {
        this.drawing = false
        if (e.type === 'move') {
          viewer.canvas.setAttribute('style', `cursor: ${this.restoreCursorMove}`)
        }
      } else {
        this.drawing = true
        if (e.type === 'move') {
          viewer.canvas.setAttribute('style', 'cursor: move')
        }
        if (e.type === 'new') {
          viewer.canvas.setAttribute('style', 'cursor: crosshair')
        }
      }
    },
    activeEvt(e, viewer) {
      console.log(e)
      viewer.canvas.setAttribute('style', `cursor: ${e.isActive ? 'crosshair' : 'auto'}`)
      if (!e.isActive) {
        this.drawing = false
        this.restoreCursorMove = 'auto'
      }
    },
    editorEvt(e, viewer) {
      console.log(e)
      if (e.type === 'move') {
        const restoreCursor = getComputedStyle(viewer.canvas).cursor
        viewer.canvas.setAttribute('style', 'cursor: move')
        this.drawing = true
      }
    },
    mouseEvt(e, viewer) {
      console.log(e)
      const restoreCursor = getComputedStyle(viewer.canvas).cursor
      if (!this.drawing) {
        if (e.type === 'onmouseover') {
          this.restoreCursorMove = restoreCursor
          viewer.canvas.setAttribute('style', 'cursor: pointer')
        } else {
          viewer.canvas.setAttribute('style', `cursor: ${this.restoreCursorMove || 'auto'}`)
        }
      }
    },
  },
  computed:{
    detailInfo: function (){
      let info=[]
      if(this.detailBox.detailClass===1)
      {
        info=[
          {
            key:'earthquake name',
            value: this.earthquakeInfoList[this.detailBox.detailIndex].earthquakeName,
          },
          {
            key:'magnitude',
            value: this.earthquakeInfoList[this.detailBox.detailIndex].magnitude,
          },
          {
            key:'position',
            value: this.earthquakeInfoList[this.detailBox.detailIndex].longitude+','+this.earthquakeInfoList[this.detailBox.detailIndex].latitude,
          },
          {
            key:'intensity of center',
            value: this.earthquakeInfoList[this.detailBox.detailIndex].highIntensity,
          },
          {
            key:'time',
            value: this.earthquakeInfoList[this.detailBox.detailIndex].earthquakeTime,
          },]
      }
      else if(this.detailBox.detailClass===2)
      {
        info=[
          {
            key:'hospital name',
            value: this.hospitalList[this.detailBox.detailIndex].name,
          },
          {
            key:'address',
            value: this.hospitalList[this.detailBox.detailIndex].address,
          },
          {
            key:'position',
            value: this.hospitalList[this.detailBox.detailIndex].lon+','+this.hospitalList[this.detailBox.detailIndex].lat,
          },
          {
            key:'city',
            value: this.hospitalList[this.detailBox.detailIndex].pname+this.hospitalList[this.detailBox.detailIndex].cityname,
          },
          {
            key:'type',
            value: this.hospitalList[this.detailBox.detailIndex].type,
          },]
      }
      else if(this.detailBox.detailClass===3)
      {
        info=[
          {
            key:'amount',
            value:this.detailBox.detailIndex,
          }]
      }
      else if(this.detailBox.detailClass===4)
      {
        info=[
          {
            key:'intensity',
            value:this.earthquakeInfoList[this.selectedEarthquakeIndex].intensityLineList[this.detailBox.detailIndex].intensity+'(选中区域外圈等烈度线)',
          },
          {
            key:'long radius',
            value:this.earthquakeInfoList[this.selectedEarthquakeIndex].intensityLineList[this.detailBox.detailIndex].longRadius+'km',
          },
          {
            key:'short radius',
            value:this.earthquakeInfoList[this.selectedEarthquakeIndex].intensityLineList[this.detailBox.detailIndex].shortRadius+'km',
          }
        ]
      }
      return info
    }
  }
}
</script>

<style scoped>
.toolbar {
  position: absolute;
  left: 1%;
  top: 1%;
  min-width: 185px;
  z-index: 100;
  color: #fff!important;
  background-color: rgba(0,0,0,.2);
}

.toolbar-item{
  margin: 5px;
}

.viewer{

  width:100%;
  height:100vh;
}
.circle {
  border-radius: 50%;
  width: 62.5px;
  height: 62.5px;
  background: var(--color);
  /* 宽度和高度需要相等 */
}
</style>
